import { getLocalizedString } from "@icarius-localization/strings";
import React from "react";

const VerticalLabel = ({ size }) => {

  const verticalLabelStyle = {
    transform: "rotate(-180deg)",
    writingMode: "vertical-lr",
    color: "white",
    textAlign: "center",
    height: size,
    width: 25,
    marginRight: 10,
  };

  return (
    <div style={{ display: 'flex' }}>
      <div
        className="whiteText"
        style={{
          ...verticalLabelStyle,
          height: `calc(${size} * 3)`,
        }}
      >
        {getLocalizedString("potential")}
      </div>
      <div>
        <div className="ninebox-high-performance" style={verticalLabelStyle}>
          {getLocalizedString("high")}
        </div>
        <div className="ninebox-medium-performance" style={verticalLabelStyle}>
          {getLocalizedString("mid")}
        </div>
        <div className="ninebox-low-performance" style={verticalLabelStyle}>
          {getLocalizedString("low")}
        </div>
      </div>
    </div>
  )
}

export default VerticalLabel;